import { safeFetchAPI, SafeFetchResponse } from '../index'
import { ApplyRewardRequest, RewardsStateResponse, RewardType, MenuType } from '../../types/widget'
import { API_BASE } from './index'

export async function applyReward(
  uid: string,
  payload: ApplyRewardRequest,
  queryParams?: {
    globalId?: string
    menuType?: MenuType
  }
): Promise<SafeFetchResponse<string>> {
  return safeFetchAPI<string>(`${API_BASE}/widget/rewards/${uid}`, {
    method: 'POST',
    payload,
    queryParams: queryParams as Record<string, string>,
  })
}

export async function getRewardState(
  uid: string,
  queryParams?: {
    rewardType?: RewardType
    deviceId?: string
    contactID?: string
  }
): Promise<SafeFetchResponse<RewardsStateResponse>> {
  return safeFetchAPI<RewardsStateResponse>(`${API_BASE}/widget/rewards/${uid}`, {
    queryParams: queryParams as Record<string, string>,
  })
}
